import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usNumericFormat',
})
export class UsNumericFormatPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    const numericValue = Number(value);
    let newValue: string;

    if (numericValue >= 1000000) {
      // Calculate the number in millions
      const numberInMillions = numericValue / 1000000;
      const roundedValue = Math.floor(numericValue / 100000) / 10;

      // Check if the original number has a fractional part after rounding down
      if (roundedValue < numberInMillions) {
        newValue = roundedValue.toFixed(1) + 't+';
      } else {
        // Remove the .0 part if the number is whole after rounding
        newValue =
          roundedValue % 1 === 0 ? roundedValue.toFixed(0) + 't' : roundedValue.toFixed(1) + 't';
      }
    } else if (numericValue >= 1000) {
      // Calculate the number in thousands
      const numberInThousands = numericValue / 1000;
      const roundedValue = Math.floor(numericValue / 100) / 10;

      // Check if the original number has a fractional part after rounding down
      if (roundedValue < numberInThousands) {
        newValue = roundedValue.toFixed(1) + 'k+';
      } else {
        // Remove the .0 part if the number is whole after rounding
        newValue =
          roundedValue % 1 === 0 ? roundedValue.toFixed(0) + 'k' : roundedValue.toFixed(1) + 'k';
      }
    } else if (numericValue >= 100) {
      // For numbers between 100 and 1000
      const roundedValue = Math.floor(numericValue);
      // Check if the original number has a fractional part
      if (roundedValue < numericValue) {
        newValue = roundedValue.toString() + '+';
      } else {
        newValue = roundedValue.toString();
      }
    } else {
      newValue = numericValue % 1 === 0 ? numericValue.toString() : numericValue.toFixed(2);
    }

    return newValue;
  }
}
